<template>
    <div class="container shadow-sm">
        <div class="toolbar">
        </div>
        <div>
            <div class="booking-config-container">
                <div class="booking-config-title">
                    <img src="@/assets/companies_logos/reservotron.png" />
                    <span class="badge bg-success" v-if="reservotronBooking && reservotronBooking.active">{{ $t("admin.configuration.booking.reservotron.currently_active_in_ondago") }}</span>
                    <span class="badge bg-danger" v-if="!reservotronBooking || !reservotronBooking.active">{{ $t("admin.configuration.booking.reservotron.currently_not_active_in_ondago") }}</span>
                </div>

                <template v-if="reservotronBooking">
                    <h5 class="service_url_label">{{ $t("admin.configuration.booking.reservotron.service_url") }}</h5>
                    <div class="field has-validation">
                        <input type="text" v-bind:class="serviceUrlClass" id="service_url_label" v-model="reservotronBooking.serviceUrl" v-on:input="handleReservotronBookingModified()">
                        <div class="invalid-feedback">
                            {{ $t("admin.configuration.booking.reservotron.errors.you_must_specify_service_url") }}
                        </div>
                    </div>
                    <div class="vsl-row vsl-multilingual-text-input-row">
                        <h5 class="inAppButtonLabel">{{ $t("admin.configuration.booking.reservotron.in_app_button_label") }}</h5>
                        <div class="field inline-field">
                            <label for="inAppButtonLabel_english" class="form-label">{{ $t("admin.configuration.booking.english_label") }}</label>
                            <input type="text" class="form-control" id="inAppButtonLabel_english" v-model="reservotronBooking.inAppButtonLabel.en" v-on:input="handleReservotronBookingModified()">
                        </div>
                        <div class="field inline-field">
                            <label for="inAppButtonLabel_french" class="form-label">{{ $t("admin.configuration.booking.french_label") }}</label>
                            <input type="text" class="form-control" id="inAppButtonLabel_french" v-model="reservotronBooking.inAppButtonLabel.fr" v-on:input="handleReservotronBookingModified()">
                        </div>
                    </div>
                            
                    <div class="toolbar">
                        <button class="btn btn-primary" v-if="reservotronBookingModified" v-on:click="handleSaveButtonClicked()">{{ $t("admin.configuration.booking.save_button") }}</button>
                        <button class="btn btn-success" v-if="!reservotronBooking || !reservotronBooking.active" v-on:click="handleActivateReservotronBookingClicked()">{{ $t("admin.configuration.booking.activate_button") }}</button>
                        <button class="btn btn-danger" v-if="reservotronBooking && reservotronBooking.active" v-on:click="handleDeactivateReservotronBookingClicked()">{{ $t("admin.configuration.booking.deactivate_button") }}</button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import BookingService from "@/service/BookingService"
import BookingConfiguration from "@/model/BookingConfiguration"

export default {
    name: "BookinConfiguration",

    data() {
        return {
            selectedPublisher: this.$store.state.currentPublisher,
            bookingService: new BookingService(),
            reservotronBooking: null,
            reservotronBookingModified: false,
            reservotronBookingIsValid: true
        }
    },

    computed: {
        serviceUrlClass() {
            return this.reservotronBookingIsValid ? "form-control" : "form-control is-invalid";
        }
    },

    methods: {
        loadReservotronBookingConfiguration() {
            this.bookingService.loadReservotronBookingConfigurationsForPublisher(this.selectedPublisher.id).then((bookingConfiguration) => {
                if (!bookingConfiguration) {
                    this.reservotronBooking = new BookingConfiguration();
                } else {
                    this.reservotronBooking = bookingConfiguration;
                }
            }).catch((error) => {
                console.log(error);
            });
        },

        saveReservotronBookingConfiguration(toggleActivation) {
            const isActiveOrWillBeActive = (!this.reservotronBooking.active && toggleActivation) || (this.reservotronBooking.active && !toggleActivation);
            if (isActiveOrWillBeActive && (this.reservotronBooking.serviceUrl == null || this.reservotronBooking.serviceUrl.trim() == "")) {
               this.reservotronBookingIsValid = false;
            } else {
                this.reservotronBookingIsValid = true;

                if (toggleActivation) {
                    this.reservotronBooking.active = !this.reservotronBooking.active;
                }

                this.bookingService.saveReservotronBookingConfigurationForPublisher(this.selectedPublisher.id, this.reservotronBooking).then(() => {
                    this.reservotronBookingModified = false;
                }).catch((error) => {
                    console.log(error);
                });
            }
        },

        handleReservotronBookingModified() {
            this.reservotronBookingModified = true;
        },

        handleSaveButtonClicked() {
            this.saveReservotronBookingConfiguration(false);
        },
        
        handleActivateReservotronBookingClicked() {
            this.saveReservotronBookingConfiguration(true);
        },

        handleDeactivateReservotronBookingClicked() {
            this.saveReservotronBookingConfiguration(true);
        }
    },

    mounted() {
        this.$store.subscribe( (mutation) => {
            if (mutation.type == "setCurrentPublisher") {
                this.selectedPublisher = mutation.payload;
                this.loadReservotronBookingConfiguration();
            }
        });

        this.loadReservotronBookingConfiguration();
    }
}
</script>

<style scoped>
.container {
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    margin: 0px;
    margin-bottom: 16px;
    padding: 24px;
    width: 100%;
    height: 100%;
    max-width: none;
    text-align: left;
}

.toolbar {
    margin-bottom: 16px;
    text-align: left;
    width: 100%;
}

.toolbar img {
    margin-right: 16px;
    width: 50px;
}

.toolbar .title {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin-right: 36px;
    max-width: 250px;
}

.field {
    margin-bottom: 16px;
}

.inline-field label {
    display: inline-block;
}

.inline-field input {
    display: inline-block;
    margin-left: 16px;
    width: 50%;
}

.toolbar button {
    margin: 0px 8px 0px 0px;
}

.booking-config-container {
    margin-bottom: 16px;
}

.booking-config-title {
    margin-bottom: 16px;
}

.booking-config-title img {
    margin-right: 16px;
}

.booking-config-container h4 {
    margin-bottom: 16px;
}

.booking-config-container .toolbar {
    margin-top: 16px;
}
</style>